import * as React from "react";
import {DynamicDialog, DynamicDialogState} from "shared/controls/Dialogs/core/DynamicDialog";
import {DialogProps} from "shared/controls/Dialogs/core/Dialog";

export class LicenseIsRequired extends DynamicDialog<LicenseIsRequiredProps,LicenseIsRequiredState> {
    static defaultProps: Partial<LicenseIsRequiredProps> = {};

    constructor(props: LicenseIsRequiredProps) {
        super(props);
        this.state = {
            IsOpen:true
        };
    }

    GetAdditionalProperties(): DialogProps {
        return {
            Title:"Full version required",
            EnableApply:true,
            EnableCancel:true,
            CancelTitle:'Close',
            ApplyTitle:'Get Full Version',
            OnApply:()=>{window.open(rednaoVar.PurchaseURL)}
        };
    }

    SubRenderer(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return this.props.Message
    }


}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface LicenseIsRequiredProps {
    Message:any
}

interface LicenseIsRequiredState extends DynamicDialogState{

}

//#endregion "My Region"